import { languages } from '../content/supportedLanguages'
import placeholderIcon from '../../assets/icons/languages/globe.svg'

export default function getLanguageIcon(languageCode) {
	if (typeof languageCode !== 'string') return languageCode

	const code = languageCode.toLowerCase()
	let languageIcon = placeholderIcon

	languages.forEach(language => {
		if (
			language.code === code &&
			language.icon &&
			language.icon !== ''
		) {
			languageIcon = language.icon
		}
	})

	return languageIcon
}


// WEBPACK FOOTER //
// ./src/utilities/language/getLanguageIcon.js